import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

class ProductTrustSignals extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  onProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = Array.from(detail.html.querySelectorAll('product-trust-signals'))
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      if (!replacement) return;
      this.dataset.productId = replacement.dataset.productId;
      morph(this, replacement, { childrenOnly: true });
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[product-trust-signals] Unable to update stock:', error);
    }
  };
}

if (!customElements.get('product-trust-signals')) {
  customElements.define('product-trust-signals', ProductTrustSignals);
}